// extracted by mini-css-extract-plugin
module.exports = {"back":"_3gKkgiWdvretfLfpETXh7K","btn":"_2t48CHEPwzZBaOr2uElLqa","toast2":"_3KVm7ySujZ1P5ddrotvZxO"};